<template>
    <div v-if="!hide" class="form-network form-network-tiktok">
       <details open>
           <summary>{{ $t('dash.post-creator.form.tiktok.privacy') }} <i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <SelectComponent 
                    :valueSelect="draftInstance.form.networks.tiktok.visibility" 
                    :changeValueSelect="changeVisibilityPost" 
                    :data="{
                        PUBLIC_TO_EVERYONE:$t('dash.post-creator.form.tiktok.visibility-public'), 
                        MUTUAL_FOLLOW_FRIENDS:$t('dash.post-creator.form.tiktok.visibility-friends'),
                        SELF_ONLY:$t('dash.post-creator.form.tiktok.visibility-me')
                    }"
                    :positionAuto="false" 
                    :positionX="'left'"
                />
                <div class="list-simple-btn" v-if="hasVideo && nativeMode">
                    <div class="type-btn-simple" @click="addMode('addTiktokMusicMode')">
                        <i class="fa-solid fa-music"></i>
                        <p>Musique <span class="pink">({{ draftInstance.form.networks.tiktok.music ? '1' : '0' }})</span></p>
                    </div>
                </div>
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.tiktok.disable-comments') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.commentDisable" :onChange="(v)=> draftInstance.form.networks.tiktok.commentDisable = v" :id="'switch-settings-advanced-tiktok-1'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                    {{ $t('dash.post-creator.form.tiktok.allow-duo') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.useVideoForDuo" :onChange="(v)=>{draftInstance.form.networks.tiktok.useVideoForDuo = v}" :id="'switch-settings-advanced-tiktok-2'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                    {{ $t('dash.post-creator.form.tiktok.allow-stitch') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.useVideoForOtherVideo" :onChange="(v)=>{draftInstance.form.networks.tiktok.useVideoForOtherVideo = v}" :id="'switch-settings-advanced-tiktok-3'"></ComponentSwitch>
                </div>
                <div v-if="hasPhotos" class="type-switch">
                    {{ $t('dash.post-creator.form.tiktok.auto-music') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.autoAddMusic" :onChange="(v)=>{draftInstance.form.networks.tiktok.autoAddMusic = v}" :id="'switch-settings-advanced-tiktok-4'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.brand-content') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.brandContentToggle" :onChange="(v)=>{draftInstance.form.networks.tiktok.brandContentToggle = v}" :id="'switch-settings-advanced-tiktok-5'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.brand-organic') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.brandOrganicToggle" :onChange="(v)=>{draftInstance.form.networks.tiktok.brandOrganicToggle = v}" :id="'switch-settings-advanced-tiktok-6'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.ai-generated') }}
                    <ComponentSwitch :value="draftInstance.form.networks.tiktok.isAigc" :onChange="(v)=>{draftInstance.form.networks.tiktok.isAigc = v}" :id="'switch-settings-advanced-tiktok-7'"></ComponentSwitch>
                </div>
           </div>
       </details>
   </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SelectComponent from '@/components/dash/utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import { VueDraft } from '@mashupweb/draft-lib';

    export default {

       components: {
           ComponentSwitch,
           SnippetNetwork,
           SelectComponent
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           draftInstance: VueDraft
       },

       data() {
           return {
               inputModel:{

               },

               lastModeSelected : undefined
           }
       },

       
       mounted() {
            EventBus.$on('eventClickSelectTiktokMusic', this.addMusic)
            EventBus.$on('eventRemoveSelectTiktokMusic', this.removeMusic)
       },

       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            changeVisibilityPost(state) {
                this.draftInstance.form.networks.tiktok.visibility = state
            },
            addMusic(music) {
                this.draftInstance.form.networks.tiktok.music = music
            },
            removeMusic() {
                this.draftInstance.form.networks.tiktok.music = null
            },
        },
        
        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            hasVideo() {
                return this.draftInstance.form.medias.some(media => media?.file?.info.type2 === 'video');
            },

            hasPhotos() {
                return this.draftInstance.form.medias.some(media => media?.file?.info.type2 === 'image');
            },

            nativeMode() {
                return this.pagesSelected.some(p => p && p.network === 'tiktok' && p.story_config && p.story_config.created)
            },

       },


       beforeDestroy () {
           EventBus.$off('eventClickSelectTiktokMusic', this.addMusic)
           EventBus.$off('eventRemoveSelectTiktokMusic', this.removeMusic)
       }
       
   }
</script>
